var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3000_186605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0156 46.2241L32.0156 44.5715L32.0156 40.7728",
    stroke: "black",
    strokeWidth: 2.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0156 36.8657L32.0156 32.2359L32.0156 16.8157",
    stroke: "black",
    strokeWidth: 2.625
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.5664 7.69888C29.542 4.27715 34.4808 4.27716 36.4563 7.69889L58.1257 45.2313C60.1012 48.653 57.6318 52.9301 53.6807 52.9301H10.342C6.39097 52.9301 3.92156 48.653 5.89709 45.2313L27.5664 7.69888Z",
    stroke: "black",
    strokeWidth: 2.625
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3000_186605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white",
    transform: "translate(0.513672)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSign);
export default __webpack_public_path__ + "static/media/error-sign.60d38182044acf68dd2a45c320198919.svg";
export { ForwardRef as ReactComponent };